import { BriefingFeedApiModel } from '../../../api/briefings/model/briefing-feed-api.model';

export class BriefingFeedModel {
    id: number;
    clearOnPublish: boolean;

    // F.E use only
    name: string;
    url: string;

    constructor(api?: BriefingFeedApiModel) {
        if (api) {
            this.id = api.id;
            this.clearOnPublish = api.clearOnPublish;
        }
    }

    setNameAndUrl(name: string, url: string): void {
        this.name = name;
        this.url = url;
    }
}
